import css from './index.module.scss';
import { getDetaileMoreProducts } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import OtherList from '@/components/ProductCommon/OtherList';

export default function EOther() {
    const { useLang, gloproductlist, useRouter } = useGlobal();
    const { t } = useLang('xstream');
    const { locale } = useRouter();

    const arr = ['mx'].includes(locale)
        ? ['product_ps_delta_delta_2', 'product_ps_delta_delta_2_max', 'product_ps_river_river_256']
        : ['au', 'za', 'sa'].includes(locale)
        ? ['product_ps_delta_delta_pro', 'product_ps_delta_delta_max', 'product_ps_river_river_pro_720']
        : ['product_ps_delta_delta_2', 'product_ps_delta_delta_max', 'product_ps_river_river_256'];

    const otherProduct = getDetaileMoreProducts(gloproductlist, arr);

    return (
        <div className={`E_other ${css.E_other}`}>
            <div className="textBox">
                <p className="title">{t('section_6_title')}</p>
                <p className="text">{t('section_6_desc')}</p>
            </div>
            <div className="container">
                <OtherList theme="black" data={otherProduct} />
            </div>
        </div>
    );
}
